import { Badge, BadgeProps } from '@chakra-ui/react'

export default Badge
export type { BadgeProps }
